module.exports = __webpack_public_path__ + "img/red-logo-eng.a910f1ba.png";